import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import "../../main-component/CaptainTCCards/CaptainTCCards.css";
import silverImg from "../../images/captain-tc/silver.png";

const ImageMagnifier = ({
  src,
  alt,
  containerStyle = {},
  imageStyle = {},
  disableOnDesktop = false,
}) => {
  const [showMagnifier, setShowMagnifier] = useState(false);
  const [position, setPosition] = useState({ x: 50, y: 50 });
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 768 : false,
  );

  useEffect(() => {
    if (typeof window === "undefined") return;
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const shouldMagnify = disableOnDesktop ? isMobile : true;
  const activeMagnifier = showMagnifier && shouldMagnify;

  const handleMouseMove = (e) => {
    const { left, top, width, height } =
      e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;
    setPosition({ x, y });
  };

  return (
    <>
      <div
        className="magnifier-container"
        onMouseEnter={() => setShowMagnifier(true)}
        onMouseLeave={() => setShowMagnifier(false)}
        onMouseMove={handleMouseMove}
        onClick={() => setShowMagnifier(true)}
        style={{
          position: "relative",
          overflow: "hidden",
          width: "180px",
          height: "240px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "8px",
          cursor: shouldMagnify ? "pointer" : "default",
          transform: activeMagnifier ? "scale(1.8)" : "scale(1)",
          zIndex: activeMagnifier ? 20 : 1,
          transition: "transform 0.2s ease-out",
          ...containerStyle,
        }}
      >
        <img
          src={src}
          alt={alt}
          className="magnifier-image"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            transform: activeMagnifier ? "scale(1)" : "scale(1)",
            transformOrigin: `${position.x}% ${position.y}%`,
            transition: activeMagnifier
              ? "transform 0.1s ease-out"
              : "transform 0.3s ease-out",
            pointerEvents: "none",
            ...imageStyle,
          }}
        />
      </div>

      {/* Mobile Center Modal via Portal to prevent z-index/transform stacking issues */}
      {activeMagnifier &&
        typeof document !== "undefined" &&
        createPortal(
          <div
            className="mobile-magnifier-modal"
            onClick={() => setShowMagnifier(false)}
          >
            <img
              src={src}
              alt={alt + " Full"}
              className="mobile-magnifier-image"
            />
            <div className="mobile-magnifier-close">Tap to close</div>
          </div>,
          document.body,
        )}
    </>
  );
};

const CaptainTCSilverCardsContent = () => {
  return (
    <div
      style={{
        maxWidth: "800px",
        margin: "0 auto",
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        color: "#333",
        lineHeight: "1.6",
      }}
    >
      <div style={{ textAlign: "center", marginBottom: "30px" }}>
        <ImageMagnifier
          src={silverImg}
          alt="Captain TC Silver Rewards Card"
          disableOnDesktop={false}
          containerStyle={{
            width: "100%",
            maxWidth: "60%",
            height: "auto",
            borderRadius: "10px",
            margin: "0 auto",
          }}
          imageStyle={{
            height: "auto",
          }}
        />
      </div>

      {/* <h2
        style={{
          textAlign: "center",
          color: "#CCCEEF",
          fontSize: "28px",
          fontWeight: "bold",
          margin: "0 0 15px 0",
        }}
      >
        Captain TC Silver Rewards Card
      </h2> */}

      <div
        style={{
          textAlign: "center",
          marginTop: "10px",
          marginBottom: "20px",
          color: "#CCCEEF",
        }}
      >
        <p
          style={{ fontWeight: "bold", fontSize: "18px", marginBottom: "10px" }}
        >
          Complete 5000 Reward TopCoin.
        </p>
        <p
          style={{ fontWeight: "bold", fontSize: "18px", marginBottom: "10px" }}
        >
          Be rewarded minimum  £75 up to £4,075*
        </p>
      </div>

      <h3
        style={{
          textAlign: "center",
          color: "#CCCEEF",
          fontSize: "22px",
          fontWeight: "bold",
          margin: "0 0 25px 0",
        }}
      >
        Exclusive Rewards
      </h3>

      <div
        style={{
          textAlign: "center",
          marginBottom: "30px",
          fontSize: "16px",
          color: "#CCCEEF",
        }}
      >
        <p style={{ margin: "0 0 15px 0" }}>
          Receive a <strong>FREE Captain TC Silver Rewards Card</strong> with a
          qualifying purchase from a participating company on the Topcoin UK
          platform.
        </p>
        <p style={{ margin: "0" }}>
          These rewards are available exclusively with the Captain TC Silver
          Rewards Card.
        </p>
      </div>

      <ol
        style={{
          paddingLeft: "20px",
          marginBottom: "30px",
          fontSize: "16px",
          color: "#CCCEEF",
        }}
      >
        <li style={{ marginBottom: "15px", paddingLeft: "10px" }}>
          <strong>Reward Topcoin</strong> - For every standard Topcoin you
          receive in your original Topcoin Wallet, you'll receive the same
          number of Reward Topcoin in your Captain TC Rewards Wallet.{" "}
          <strong>Bonus Topcoin are excluded.</strong>
        </li>
        <li style={{ marginBottom: "15px", paddingLeft: "10px" }}>
          <strong>£50 Rewards</strong> - Receive £2.50 for every 250 Reward
          Topcoin. Earn this 20 times:{" "}
          <strong>5,000 Reward Topcoin = £50.</strong>
        </li>
        <li style={{ marginBottom: "15px", paddingLeft: "10px" }}>
          <strong>Captain TC Gold Card Access</strong> - Your Captain TC Silver
          Rewards Card gives you access to collect Captain TC Gold Cards on
          qualifying product purchases from participating companies on the
          Topcoin UK platform. Collect <strong>20 Captain TC Gold Cards</strong>{" "}
          and receive a <strong>£16 reward</strong>.
        </li>
        <li style={{ marginBottom: "15px", paddingLeft: "10px" }}>
          <strong>5,000 Reward Topcoin Per Card</strong> - Each card is valid
          for up to 5,000 Reward Topcoin. Once you reach 5,000, your card is
          complete and you can receive a new card to continue earning rewards.
        </li>
      </ol>

      <div
        style={{
          border: "1px solid #CCCEEF",
          padding: "20px",
          color: "#CCCEEF",
          fontWeight: "bold",
          fontSize: "16px",
          textAlign: "center",
        }}
      >
        One Card at a Time - You can have only one active Captain TC Rewards
        Card at a time - Bronze, Silver or Gold. Reach 5,000 Reward Topcoin to
        complete your current card before receiving a new one.
      </div>
    </div>
  );
};

export default CaptainTCSilverCardsContent;
